   
// function observeElementLoad(elementId, callback) {
//     const targetNode = document.body;
//     if (!targetNode) {
//         console.error('Target node (body) not found.');
//         return;
//     }
//     const config = { childList: true, subtree: true };
//     const observerCallback = function(mutationsList, observer) {
//         for (let mutation of mutationsList) {
//             if (mutation.type === 'childList' || mutation.type === 'attributes') {
//                 const element = document.getElementById(elementId);
//                 if (element) {
//                     console.log(`Element ${elementId} rendered.`);
//                     callback();
//                     observer.disconnect(); 
//                     break; 
//                 }
//             }
//         }
//     };
//     const observer = new MutationObserver(observerCallback);
//     observer.observe(targetNode, config);
// }




//防抖 immediate immediate 参数来控制是否立即执行函数。例如：debounce(search, 500, true) 会立即执行搜索函数，并且在500毫秒后不再重复
// function utiles_debounce(func, wait, immediate) {
//     let timeout;
//     return function executedFunction(...args) {
//         const context = this;
//         const later = function() {
//             timeout = null;
//             if (!immediate) func.apply(context, args);
//         };
//         const callNow = immediate && !timeout;
//         clearTimeout(timeout);
//         timeout = setTimeout(later, wait);
//         if (callNow) func.apply(context, args);
//     };
// }

function utiles_debounce(fn, delay) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn();
      }, delay);
    };
  }
  


  function disableScroll() {
 
  $(window).on('wheel.disableScroll DOMMouseScroll.disableScroll touchmove.disableScroll', function(e) {
    e.preventDefault();
  });
 
  $(document).on('keydown.disableScroll', function(e) {
   
    const keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    if (keys.includes(e.keyCode)) {
      e.preventDefault();
    }
  });
}


function enableScroll() {
  $(window).off('.disableScroll');
  $(document).off('.disableScroll');
}



    //  document.addEventListener("DOMContentLoaded", function() {
    //         // 获取所有需要懒加载的图片
    //         var lazyImages = document.querySelectorAll('img.lazyloaded');

    //         // 设置 IntersectionObserver 用于懒加载
    //         var observer = new IntersectionObserver(function(entries, observer) {
    //           entries.forEach(function(entry) {
    //             if (entry.isIntersecting) {
    //               // 加载高分辨率图片
    //               var img = entry.target;
    //               var highResSrc = img.getAttribute('data-src');
    //               img.src = highResSrc;  // 设置为高清图像

    //               // 图片加载完成后，移除懒加载类
    //               img.onload = function() {
    //                 img.classList.remove('lazyloaded');
    //               };

    //               // 停止观察这张图片
    //               observer.unobserve(img);
    //             }
    //           });
    //         }, {
    //           rootMargin: '100px', // 在图片接近视口时提前加载
    //           threshold: 0.1 // 触发加载的阈值，当图片 10% 进入视口时开始加载
    //         });

    //         // 为每张懒加载图片添加观察
    //         lazyImages.forEach(function(img) {
    //           observer.observe(img);
    //         });
    //       });


    // 控制鼠标滚动
    function controlMouseScroll(className) {
          let categoryFilterList = document.querySelector(className);
          if (!categoryFilterList || window.innerWidth > 767) return;
         // 1. 先确保元素样式支持滚动（避免样式问题导致滚动失效）
          categoryFilterList.style.overflowY = 'auto';
          categoryFilterList.style.overflowX = 'hidden'; // 防止横向滚动干扰
          categoryFilterList.style.height = categoryFilterList.style.height || 'auto'; // 确保高度可计算

          // 2. 调整滚动步长（核心：增大数值提升速度，默认20，可根据需求调整）
          const SCROLL_STEP = 20; // 原10 → 改为20，滚动速度翻倍；可调整为25/30进一步加快

          // 3. 同时监听 wheel 和 mousewheel（兼容旧版浏览器）
          const handleScroll = function(event) {
            // 强制阻止所有默认滚动行为（不管是否可滚动，先阻止）
            event.preventDefault();
            event.stopPropagation(); // 阻止事件冒泡到文档

            const el = this;
            // 只在元素可滚动时调整内部滚动
            if (el.scrollHeight > el.clientHeight) {
              // 核心：使用更大的步长值提升滚动速度
              const delta = Math.sign(event.deltaY || event.wheelDeltaY || -event.wheelDelta) * SCROLL_STEP;
              let newScrollTop = el.scrollTop + delta;
              // 严格限制滚动边界
              newScrollTop = Math.max(0, Math.min(newScrollTop, el.scrollHeight - el.clientHeight));
              el.scrollTop = newScrollTop;
            }
            // 元素不可滚动时，阻止默认行为后也不会触发页面滚动
          };

          // 4. 多个事件 + 捕获阶段 + passive: false（最大化兼容性）
          categoryFilterList.addEventListener('wheel', handleScroll, { passive: false, capture: true });
          categoryFilterList.addEventListener('mousewheel', handleScroll, { passive: false, capture: true }); // 兼容IE/旧Chrome

          // 5. 额外防护：阻止触摸滚动（如果是移动端/触控屏）
          categoryFilterList.addEventListener('touchmove', function(event) {
            event.preventDefault();
            event.stopPropagation();
          }, { passive: false, capture: true });

    }